<template>
  <div :class="['container', ' profile']">

        <div class="row">
          <div :class="['col-12', 'mt-3', 'mb-3']">
            <div :class="['borderR5', 'my-1']">
            <Fleets></Fleets>
            </div>
          </div>
          <div :class="['col-xs-12 col-md-3 col-12']">
          <Vessels></Vessels>
          </div>
          <div :class="['col-xs-12 col-md-9 col-12']">
            <VesselForm></VesselForm>
          </div>
</div>
  </div>
</template>

<style>
  .borderR5:not(.nb) {
    padding-top: 10px !important;
  }
  .borderR5.fleet-item.mt-3 {
    max-height: calc(100vh - 250px);
    overflow-y: scroll;
  }
  a:hover, a:focus {
    color: rgb(47, 135, 226);
  }
  .my-1{
    margin-right: 10px;
    margin-left: 10px;
  }
  @media (max-width:768px){
    ul.fleet-list{
      flex-flow: column wrap!important;
    }
  }
</style>
<script>
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex';
import Fleets from './components/Fleets.vue'
import Vessels from './components/Vessels.vue'
import VesselForm from './components/VesselForm.vue'



export default{
    components: {
        Fleets,
        Vessels,
        VesselForm
    },

    computed: {
        ...mapGetters(['fleets', 'isLoaded'])
    },
    methods: {
        ...mapActions([
             'setLng',
             'setFleets',
             'setVesselsType',
             'setCountries'
         ])

    },


     created(){
        axios.get(langUrl + "/" + lang + ".json")
        .then(response => {
            this.setLng(response.data);
        });
        axios.post(location.href, {
             action: 'getInitialData'
        }).then(response => {
                  this.setFleets(response.data.items);
                  this.setCountries(response.data.countries);
             if(typeof response.data !== "undefined") {}
       })
       ;
    }

}
</script>



// WEBPACK FOOTER //
// App.vue?5c71724a